import { createContext, useContext, useEffect, useState } from 'react';
import { deepMerge } from '@/utils';
import { useLayout } from '@/providers';
import { PublicLayoutConfig } from './PublicLayoutConfig';

// Defining the structure for the PublicLayoutProvider's props, which contains a layout of type ILayoutConfig

// Initial layout properties for the PublicLayoutProvider, using PublicLayoutConfig as the default configuration
const initalLayoutProps = {
  layout: PublicLayoutConfig
};

// Creating a context for the PublicLayout with the initial layout properties
const LayoutContext = createContext(initalLayoutProps);

// Custom hook to access the PublicLayout context, allowing other components to use the layout data
const usePublicLayout = () => useContext(LayoutContext);

// PublicLayoutProvider component that wraps its children with the layout context
const PublicLayoutProvider = ({
  children
}) => {
  const {
    getLayout,
    setCurrentLayout
  } = useLayout(); // Access layout-related functions

  // Function to merge the current layout with the public layout configuration
  const getLayoutConfig = () => {
    return deepMerge(PublicLayoutConfig, getLayout(PublicLayoutConfig.name));
  };

  // Setting the layout state with the merged layout configuration
  const [layout] = useState(getLayoutConfig);

  // Effect hook to set the current layout whenever the layout state changes
  useEffect(() => {
    setCurrentLayout(layout);
  });

  // Providing the layout context to all child components wrapped by PublicLayoutProvider
  return <LayoutContext.Provider value={{
    layout
  }}>
      {children}
    </LayoutContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components
export { PublicLayoutProvider, usePublicLayout };